__turbopack_context__.v({
  "cardContent": "XFNzmG_cardContent",
  "featuresWrapper": "XFNzmG_featuresWrapper",
  "icon": "XFNzmG_icon",
  "infoBlock": "XFNzmG_infoBlock",
  "infoItem": "XFNzmG_infoItem",
  "listItemContent": "XFNzmG_listItemContent",
  "listItemRoot": "XFNzmG_listItemRoot",
  "listItemRootSelected": "XFNzmG_listItemRootSelected",
  "priceWrapper": "XFNzmG_priceWrapper",
  "priceWrapperSelected": "XFNzmG_priceWrapperSelected",
});
